[
    {
        "key": "2.2",
        "zoomout": 1.1,
        "z": 1,
        "points": [
            {
                "x": 19,
                "y": 12,
                "key": "62plJg7HdKA3zYC3pstjp"
            },
            {
                "x": 23,
                "y": 12,
                "key": "XOmNsDVwHXuDYaMugLxjk"
            },
            {
                "x": 23,
                "y": 17,
                "key": "YfHpdb0w6Syck-ec8N2a1"
            },
            {
                "x": 19,
                "y": 17,
                "key": "vdDUpxqgA7-eps6zzzJbd"
            }
        ]
    },
    {
        "key": "2.1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 19,
                "y": 17,
                "key": "CxLsa_EV_UZkuV7H3VdSY"
            },
            {
                "x": 14,
                "y": 17,
                "key": "_4nidJOvcEIjbV7a3eq1w"
            },
            {
                "x": 14,
                "y": 16,
                "key": "jS-qc-PZRNH00v7Yw3axN"
            },
            {
                "x": 12,
                "y": 16,
                "key": "eIjDBwuLAbFAYKttUiEx7"
            },
            {
                "x": 12,
                "y": 15,
                "key": "7So6TWSr497n8LXddoRr5"
            },
            {
                "x": 11,
                "y": 15,
                "key": "4sVL7wnooM2dUl0hNfZhT"
            },
            {
                "x": 11,
                "y": 14,
                "key": "3E3jOApJOUAdgeF1fc2L1"
            },
            {
                "x": 12,
                "y": 14,
                "key": "KIegpaIJlHpaXfm-WDncy"
            },
            {
                "x": 12,
                "y": 13,
                "key": "LjSr6D-ajMO6Rd2hlB_dY"
            },
            {
                "x": 14,
                "y": 13,
                "key": "JGkj_pKNQ1wWTPW7wJwY9"
            },
            {
                "x": 14,
                "y": 12,
                "key": "sYacI3iAXTHHXadeh_6Q7"
            },
            {
                "x": 19,
                "y": 12,
                "key": "8O3PIlFWacVTyAKatu_we"
            }
        ]
    },
    {
        "key": "2.3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 23,
                "y": 12,
                "key": "pcn28TX_DTsI6BZDJhgav"
            },
            {
                "x": 29,
                "y": 12,
                "key": "8ZxQTy6yKyfyk-o9l_7Bf"
            },
            {
                "x": 29,
                "y": 13,
                "key": "j3Rr0IVR11iJf02KhHrFt"
            },
            {
                "x": 30,
                "y": 13,
                "key": "e7nLJrB3kLuCFoddsTkiG"
            },
            {
                "x": 30,
                "y": 16,
                "key": "9LN2WWTgwUaYfAZPCLVj8"
            },
            {
                "x": 29,
                "y": 16,
                "key": "zc4XH8mcJULr1GCYH3RLb"
            },
            {
                "x": 29,
                "y": 17,
                "key": "hpGYMLPq9-6VG7vBm9SGJ"
            },
            {
                "x": 23,
                "y": 17,
                "key": "K6d94I8s5f7q4nmT8ETvI"
            }
        ]
    },
    {
        "key": "1.2",
        "zoomout": 0.8,
        "z": 1,
        "points": [
            {
                "x": 19,
                "y": 27,
                "key": "cYO43bYjPLPg8wSellbkY"
            },
            {
                "x": 23,
                "y": 27,
                "key": "p82YElSAzG4SXeCTgD4CN"
            },
            {
                "x": 23,
                "y": 32,
                "key": "ZwVaSZL5kAnK0nDZspz3b"
            },
            {
                "x": 19,
                "y": 32,
                "key": "UBnzeWBFCLeYYzn2aFQ_n"
            }
        ]
    },
    {
        "key": "1.1",
        "zoomout": 0.8,
        "z": 1,
        "points": [
            {
                "x": 19,
                "y": 32,
                "key": "D8HqMcL0GhtPILwVdT-Bw"
            },
            {
                "x": 14,
                "y": 32,
                "key": "L74OxniH-t2DJO0UWkPVN"
            },
            {
                "x": 14,
                "y": 31,
                "key": "sh7g-IXwNHp7tvYp7Hf7f"
            },
            {
                "x": 12,
                "y": 31,
                "key": "Oc_NvH-eBaq9fHdb848_2"
            },
            {
                "x": 12,
                "y": 30,
                "key": "qerh1mdzSG64n0imrEtsY"
            },
            {
                "x": 11,
                "y": 30,
                "key": "VAWP_plzm3byNpUzX__QP"
            },
            {
                "x": 11,
                "y": 29,
                "key": "6ud7VJakAjV4RREJ7X6LY"
            },
            {
                "x": 12,
                "y": 29,
                "key": "8lwfaNaBjoSbqSiv1lm7K"
            },
            {
                "x": 12,
                "y": 28,
                "key": "qH9oKXH5gKhXxFG7_il63"
            },
            {
                "x": 14,
                "y": 28,
                "key": "z2F4zKQNuEIuRSE6MAKdE"
            },
            {
                "x": 14,
                "y": 27,
                "key": "a94Se1Q5R099rhmiPw4RK"
            },
            {
                "x": 16,
                "y": 27,
                "key": "FziQrPXxowSNHMHYLv_Pd"
            },
            {
                "x": 19,
                "y": 27,
                "key": "iVoWMT7J0f7EqqZ7rZdMC"
            }
        ]
    },
    {
        "key": "1.3",
        "zoomout": 0.8,
        "z": 1,
        "points": [
            {
                "x": 23,
                "y": 27,
                "key": "mLWQ-gufarVvLOf5oK0jw"
            },
            {
                "x": 28,
                "y": 27,
                "key": "pORkrXCau4QpuD5oxd5ZN"
            },
            {
                "x": 28,
                "y": 28,
                "key": "LdDZzSjnF05uALh-G7Wxk"
            },
            {
                "x": 29,
                "y": 28,
                "key": "N_8jfK3RXRyaQhKkS612z"
            },
            {
                "x": 29,
                "y": 31,
                "key": "jnkp70ggfYTntj74v-CTi"
            },
            {
                "x": 28,
                "y": 31,
                "key": "VimPmwVnZ1mY1o96fJTWS"
            },
            {
                "x": 28,
                "y": 32,
                "key": "f12FQmtTiNt04vy9Sx_Ly"
            },
            {
                "x": 23,
                "y": 32,
                "key": "bf5oCW4UQdsTMnAdg73Gg"
            }
        ]
    }
]
